import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.75, ease: EASE, delay: i * 0.08 },
  }),
};

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.15 }}
      transition={{ duration: 0.75, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

/** Kinetic masked line-by-line headline reveal. */
export function KineticLines({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1", animateOnLoad = false }) {
  const reduced = useReducedMotion();
  const animProps = animateOnLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.4 } };

  if (reduced) {
    return (
      <Tag className={className}>
        {lines.map((l, i) => (
          <span key={i} className={`block ${lineClassName}`}>{l}</span>
        ))}
      </Tag>
    );
  }
  return (
    <Tag className={className} {...animProps}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className={`line-inner ${lineClassName}`}
            variants={{
              hidden: { y: "112%" },
              show: { y: "0%", transition: { duration: 0.95, ease: EASE, delay: delay + i * 0.11 } },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function SectionLabel({ children, dark = false }) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 text-xs font-bold uppercase tracking-wider2 ${
        dark ? "text-teal-bright" : "text-royal"
      }`}
    >
      <span className={`h-px w-8 ${dark ? "bg-teal-bright" : "bg-teal"}`} aria-hidden="true" />
      {children}
    </span>
  );
}
